import React from 'react';
import { Shield, Zap, Award, Wrench, ClipboardCheck } from 'lucide-react';
import { advantages } from '../data/mock';

const iconMap = {
  Shield: Shield,
  Zap: Zap,
  Award: Award,
  Wrench: Wrench,
  ClipboardCheck: ClipboardCheck
};

const Advantages = () => {
  return (
    <section id="advantages" className="py-24 bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#FF6600] font-semibold text-sm uppercase tracking-wider">Notre Expertise</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mt-3 mb-4">
            Pourquoi Choisir Orion Industrie ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Une expertise reconnue dans l'installation et la maintenance d'équipements de quai
          </p>
        </div>

        {/* Advantages Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6">
          {advantages.map((advantage) => {
            const IconComponent = iconMap[advantage.icon];
            return (
              <div 
                key={advantage.id}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border border-gray-200 group"
              >
                <div className="bg-gradient-to-br from-[#FF6600] to-[#E65A00] w-16 h-16 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">
                  {advantage.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {advantage.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Stats Section */}
        <div className="mt-20 bg-gradient-to-r from-[#020d2a] to-[#03152f] rounded-2xl p-12 shadow-2xl">
          <div className="grid md:grid-cols-2 gap-8 text-center">
            <div className="border-r border-gray-600 last:border-r-0">
              <p className="text-5xl font-bold text-[#FF6600] mb-2">7+</p>
              <p className="text-gray-300 text-lg">Années d'expérience</p>
            </div>
            <div>
              <p className="text-5xl font-bold text-[#FF6600] mb-2">24-48h</p>
              <p className="text-gray-300 text-lg">Dépannage selon localisation</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Advantages;
